import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";

const primaryBtn =
  "inline-flex min-h-12 items-center justify-center gap-2 rounded-md bg-[#8B4AFA] px-6 py-3 text-sm font-semibold text-white shadow-[5px_5px_0_#6e3fc7] transition-transform duration-200 hover:-translate-y-0.5 hover:bg-[#7c3aed] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8B4AFA]";

const NotFound = () => {
  return (
    <div className="mk-page relative overflow-x-clip text-slate-900">
      {/* React 19 moves these tags into <head> automatically */}
      <title>Page Not Found | MK AI Technologies</title>
      <meta name="robots" content="noindex, follow" />

      <section className="px-4 pb-24 pt-40 text-center sm:px-6 sm:pt-44">
        <div className="mx-auto max-w-2xl">
          <p className="inline-flex items-center gap-2 rounded-md border border-[#8B4AFA]/20 bg-white/80 px-3 py-1.5 text-xs font-semibold uppercase text-[#6e3fc7]">
            <span className="h-1.5 w-1.5 rounded-full bg-[#8B4AFA]" />
            Error 404
          </p>

          <h1 className="mt-6 font-display text-4xl font-semibold leading-[1.1] text-slate-900 sm:text-5xl lg:text-6xl">
            Page not found
          </h1>

          <p className="mx-auto mt-6 max-w-xl text-base leading-7 text-slate-600 sm:text-lg">
            The page you are looking for does not exist or may have been moved.
            Let's get you back on track.
          </p>

          <div className="mt-9 flex flex-col items-stretch justify-center gap-4 pb-1.5 pr-1.5 sm:flex-row sm:items-center">
            <Link to="/" className={`${primaryBtn} w-full sm:w-auto`}>
              Back to Home <FaArrowRight aria-hidden="true" className="h-3 w-3" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NotFound;